var map = {
	"./coin-icon.svg": "f639",
	"./favorite_icon.svg": "2342",
	"./flags/az.svg": "4e9e",
	"./flags/be.svg": "4bad",
	"./flags/en.svg": "db2d",
	"./flags/et.svg": "029e",
	"./flags/hy.svg": "2719",
	"./flags/ka.svg": "98c1",
	"./flags/kk.svg": "0e65",
	"./flags/ky.svg": "80f4",
	"./flags/lt.svg": "c8ac",
	"./flags/lv.svg": "0896",
	"./flags/mn.svg": "1974",
	"./flags/ru.svg": "e727",
	"./flags/uz.svg": "e226",
	"./like_icon.svg": "3cf1",
	"./ok.ru.svg": "c773",
	"./ok_icon.svg": "8fdd",
	"./t.me.svg": "1811",
	"./tg.svg": "235c",
	"./tg_icon.svg": "8637",
	"./vk.com.svg": "64b0",
	"./vk_icon.svg": "d93a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "909e";